import { render, staticRenderFns } from "./PdfRule.vue?vue&type=template&id=2721fdc8&scoped=true"
import script from "./PdfRule.vue?vue&type=script&lang=js"
export * from "./PdfRule.vue?vue&type=script&lang=js"
import style0 from "./PdfRule.vue?vue&type=style&index=0&id=2721fdc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2721fdc8",
  null
  
)

export default component.exports